import type { MonthlyRecapsArticle } from '@/features/monthly-recaps';

import { MonthlyRecapsArticleTeaser } from './MonthlyRecapsArticleTeaser';

type MonthlyRecapsSingleViewProps = {
  article: MonthlyRecapsArticle;
  onSelectArticle: (article: MonthlyRecapsArticle, trigger: HTMLButtonElement) => void;
};

export const MonthlyRecapsSingleView = ({
  article,
  onSelectArticle
}: MonthlyRecapsSingleViewProps) => (
  <MonthlyRecapsArticleTeaser
    article={article}
    variant='single'
    onClick={trigger => {
      onSelectArticle(article, trigger);
    }}
  />
);
